module.exports = __webpack_public_path__ + "img/2.2b995c92.jpg";